import { Component, OnInit, Input, ViewChild, ElementRef, HostBinding, HostListener, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import { MatDialog } from "@angular/material/dialog";
import { DialogService } from "src/app/services/dialog.service";
import { DataService } from "src/app/services/data.service";
import { ColDef } from "ag-grid-community";
import { Observable, Subscription } from "rxjs";
import { AgGridAngular } from "ag-grid-angular";
import { GanttChartComponent } from "../../shared/charts/gantt-chart/gantt-chart.component";
import { IconChartComponent } from "../../shared/charts/iconEvent-chart/icon-chart.component";
import { PopupStatusComponent } from "../../shared/popup-status/popup-status.component";
import { NewFilterService } from "src/app/services/new-filter.service";
import { ActivatedRoute } from "@angular/router";
import { FilterService } from "src/app/services/filter.service";
import { NavigationService } from "src/app/services/navigation.service";

@Component({
  selector: "app-patient-journey-card",
  templateUrl: "./patient-journey-card.component.html",
  styleUrls: ["./patient-journey-card.component.scss"],
})
export class PatientJourneyCardComponent implements OnInit {
  static key = 100503;
  showKPIPopup: boolean = false;
  isOpen: boolean = false;
  popupOpen: boolean = false;
  isActive: boolean = false;
  widgets: any = [];
  gridData: any;
  columnDefs: ColDef[] = [];
  iconList: any = [];
  ganttData: any;
  rowData: any;
  defaultColDef = {
    sortable: true,
    filter: true,
  };
  tooltipInfo: any;
  sampleVariable!: GanttChartComponent;
  reqSubcription: Subscription[] = [];
  alertIcons: any;
  clientKey: any;
  moduleKey: any;
  dashboardKey: any;
  cardName: any;
  cardId: any;
  patientId: any;
  employeeKey: any;
  isPortraitMode: boolean = false
  gridsize: any = 30;
  loader = true;
  patientCardData:any = [];


  @ViewChild("prompt", { static: true }) prompt!: ElementRef;
  @ViewChild("GanttChartContainer", { read: ElementRef }) sample!: ElementRef;
  @ViewChild("patientJourneyDiv", { static: true }) patientJourneyDiv!: ElementRef;
  
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  
  @Input("heading") heading: string = "";
  @Input('item') item: any
  @Input("pageKey") pageKey: any;

  isFullscreen= false;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.checkOrientation();
  }

  emitLoader(event:any) {
    this.loader = event.loader;
    this.patientCardData = event.data;
    this.cdr.detectChanges();
  }
  
  checkOrientation() {
    console.log(this.isPortraitMode)
    if (this.checkIPad()) {
      this.isPortraitMode = false
    } else if (this.checkMobile()) {
      this.isPortraitMode = window.innerHeight > window.innerWidth;
    } else {
      this.isPortraitMode = false
    }
  }
  constructor(
    private dialog: MatDialog,
    private dialogService: DialogService,
    public dataService: DataService,
    private newFilterService: NewFilterService,
    public filterService: FilterService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef
  ) {

    // Export Excel for Gantt chart
    this.reqSubcription.push(this.dataService.chartData.subscribe((res:any)=> {
      this.ganttData = res ? res : []
    }))
  }
  // Full Screen Functionality 

  fullscreenChanges(fullscreen:any){
    this.isFullscreen = fullscreen;
    this.isActive = fullscreen;
  }

  ngOnInit(): void {
    
    // Auto Size from Element
    const observer = new ResizeObserver((e: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(e[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.patientJourneyDiv?.nativeElement);

    this.checkOrientation();

    this.route.params.subscribe((p: any) => {
      this.cardName = p['cardName'] || '';

      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];
        this.dashboardKey = decryptedParams["ds_key"];
        this.patientId = decryptedParams["cardId"];
        this.cardId = decryptedParams["cardId"];
      });
    });

    this.widgets = this.item ? this.item : ''
    this.iconList = this.widgets?.config?.icon
    this.alertIcons = this.item?.config.alerts_config?.controls ? this.item?.config.alerts_config?.controls : sessionStorage.getItem('alertIcons')

    document.addEventListener('fullscreenchange', (event) => {
      if (document.fullscreenElement) {
        document.getElementById('kpi_gantt_popup')?.setAttribute('style', 'right:50px !important;visibility:hidden')
        this.isFullscreen = true
        this.isActive = true
      } else {
        document.getElementById('kpi_gantt_popup')?.setAttribute('style', 'right:15px;visibility:hidden')
        this.isFullscreen = false
        this.isActive = false
      }
    })

  }

  ngOnDestroy() {
    this.reqSubcription.forEach((res: any) => res.unsubscribe());
  }

  kpiPopup() {
    document.getElementById('d3Tooltip')?.setAttribute('style', 'visibility:hidden;left:unset;right:unset;top:unset;bottom:unset;position:absolute')
    this.showKPIPopup = true;
    document.getElementById('kpi_gantt_popup')?.setAttribute('style', 'visibility:visible')
  }

  resData: any;
  baseQueryFromSession: any

  changeStatus() {
    this.filterService.baseQuery = this.newFilterService.getPatientStatusBaseQuery()
    // patient status and patient reason we need to know, when navigate to Patient Card
    const obj = {
      api_key: 6001,
      report_typ: "D",
      patient_id: this.cardId,
      client_key: this.clientKey || "",
    }
    let endPoint = this.item.config?.["list_of_api_endpoint"];
    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      this.filterService.executePatientQuery(obj, endPoint).subscribe((res: any) => {
        let response: any = res ? res : []
        let findPatient = response.find((fnd: any) => fnd.patient_id == this.cardId)
  
        let resData = {
          api_key: 100202,
          patient_status: null,
          report_typ: "D",
          patient_case_status: findPatient.case_status,
          patient_reason_status: findPatient.status_reason,
          patient_id: findPatient.patient_id
        }
  
        if (this.cardName == 'pwt' || this.cardName == 'paCard' || this.cardName == 'card') {
  
          this.newFilterService.sendData(resData);
  
          this.dialog.open(PopupStatusComponent, {
            disableClose: true,
            width: '400px',
            height: '75',
            data: {endpoint: this.item.config?.widget_endpoint || 'pss/get-pss-data'}
          });
        }
      })
    }
  }

  updateSetting(event: any) {
    this.gridsize = event.value;

    if (this.gridsize == this.filterService.sliderValue) {
      this.filterService.refreshAlertDelete.next(true)
    }
  }

  // Check if the device is an iPad
  checkIPad() {
    return navigator.userAgent.match(/iPad/i) !== null;
  }

  // Check if the device is a mobile device
  checkMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
